import { useMutation } from "@tanstack/react-query";
import { llmService } from "../services/llmService";
import { useNewton } from "../store/NewtonContext";
import { getSessionIdFromName } from "../utils/getSessionIdFromName";
import { formatUserMessage } from "../utils/sse";

export function useLlmSessionById() {
  const { llmEnv } = useNewton();

  return useMutation({
    mutationFn: async ({ sessionId }) => {
      const res = await llmService.getSessionById({
        env: llmEnv,
        sessionId,
      });
      const events = await res.json();

      const messages = (
        Array.isArray(events?.sessionEvents) ? events.sessionEvents : []
      )
        .filter((el) => {
          return el?.content?.parts && el?.content?.parts[0]
            ? el?.content?.parts[0]?.text
            : "";
        })
        .map((message) => {
          const parts = Array.isArray(message?.content?.parts)
            ? message.content.parts
            : [];

          const textPart = parts.find(
            (part) => part && typeof part.text === "string" && part.text
          );

          const attachedFilesLength = parts.filter(
            (part) =>
              part &&
              // Backend may return either camelCase (`fileData`) or snake_case (`file_data`)
              (part.fileData || part.file_data)
          ).length;

          const timestampMs = message?.timestamp
            ? new Date(message.timestamp).getTime()
            : Date.now();

          const isUser = message?.author === "user";
          const rawText = textPart?.text || "";
          const displayText = isUser ? formatUserMessage(rawText, parts) : rawText;

          return {
            attachedFilesLength,
            from: isUser ? "user" : "assistant",
            message: displayText,
            pending: false,
            timestamp: timestampMs,
            sessionId: getSessionIdFromName(message?.name) || sessionId,
          };
        })
        .sort((a, b) => (a.timestamp || 0) - (b.timestamp || 0));

      return { messages };
    },
  });
}
